import { useAuth } from 'app/context';
import { Breadcrumb } from 'app/shared';
import { AdminProfile } from './AdminProfile';
import { MedicalCenterProfile } from './MedicalCenterProfile';

export const Profile = () => {
  const { loggedUser } = useAuth();

  return (
    <>
      <Breadcrumb />
      {loggedUser?.role === 'admin' && <AdminProfile loggedUser={loggedUser} />}
      {loggedUser?.role === 'medical_center' && <MedicalCenterProfile loggedUser={loggedUser} />}
    </>
  );
};
